
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M162.642 148.337h56.034v215.317h-56.034V148.338z"}}),_c('path',{attrs:{"d":"M293.356 148.337h56.002v215.317h-56.002V148.338z"}})])
          )
        }
      }
    